<template>
<div class="contract-view">
    <div class="popup" :class="{ 'is-active': isFinalContractDispute }">
      <div class="overlay"></div>
      <div class="popup-body d-flex justify-content-center align-items-center pr-4 pl-4">
        <div class="card">
          <div class="card-body text-center">
            <div class="text-center p-2">
              <h3 class="font-weight-normal mb-2">แก้ไขสัญญาและส่งกลับให้ผู้ขอกู้แล้ว</h3>
              <p class="pr-4 pl-4">รอผู้ขอกู้ยอมรับเงื่อนไขใหม่</p>
            </div>
            <a class="btn btn-primary btn-lg btn-block mt-5 mb-4" :href="$util.url('member/home')">กลับสู่หน้าหลัก</a>
          </div>
        </div>
      </div>
    </div>
    <div class="popup" :class="{ 'is-active': isFinalContractView }">
      <div class="overlay"></div>
      <div class="popup-body d-flex justify-content-center align-items-center pr-4 pl-4">
        <div class="card">
          <div class="card-body text-center">
            <!-- <div class="img-container text-center mb-4 mt-4">
              <img :src="person.avatarPath">
            </div> -->
            <div class="text-center p-2">
              <h3 class="font-weight-normal mb-2">{{display.popup.title}}</h3>
              <p class="pr-4 pl-4">{{display.popup.description}}</p>
            </div>
            <a class="btn btn-primary btn-lg btn-block mt-5 mb-4" :href="$util.url('member/home')">กลับสู่หน้าหลัก</a>
          </div>
        </div>
      </div>
    </div>
    <error-cant-reach-server :errorData="errorData"  class="mt-2 mr-2 ml-2" v-if="isCantReach" @clickCTA="$reloadPage()"></error-cant-reach-server>
    <div v-else-if="isPreProcessing" class="container text-center p-4">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <template v-else>
      <ContractFlowPairDisplay :contract="contract" :isViewingEdited="contract.status === 'disputed'" :isCredit="isShowingCredit" :isAllowShowingViewCreditButton="contract.status === 'wait_for_approve' && contract.isSendCredit"></ContractFlowPairDisplay>
      <div v-if="contract.type === 'MONEY' || contract.type === 'THING'" class="container pr-4 pl-4 pt-2 pb-2">
          <template v-if="contract.type === 'THING'">
            <div class="row mt-4 mb-4">
              <div class="col">
                  <h6 class="font-weight-normal text-secondary">ชื่อรายการสินค้า</h6>
                  <h6>{{contract.info.thingPayload.thingName}}</h6>
              </div>
            </div>
            <div class="row mt-4 mb-4">
              <div class="col">
                  <h6 class="font-weight-normal text-secondary">เงินดาวน์ / เงินมัดจำ</h6>
                  <h6>{{contract.info.thingPayload.downPaymentAmount | money}}</h6>
              </div>
            </div>
            <div class="row mt-4 mb-4">
              <div class="col">
                  <h6 class="font-weight-normal text-secondary">รูปถ่ายแนบสัญญา</h6>
                  <ImageViewer v-model="contract.info.thingPayload.imageURLs"></ImageViewer>
              </div>
            </div>
            <hr>
          </template>

          <div class="row mt-4 mb-4">
              <div class="col">
                  <h6 class="font-weight-normal text-secondary" v-if="contract.type === 'MONEY'" for="amount">จำนวนเงินที่ขอกู้</h6>
                  <h6 class="font-weight-normal text-secondary" v-else for="amount">ราคาขายสินค้า</h6>
                  <h6>{{contract.info.moneyPayload.amount | money}}</h6>
              </div>
              <div class="col">
                  <h6 class="font-weight-normal text-secondary">ดอกเบี้ย (%)</h6>
                  <h6>{{$big(contract.info.moneyPayload.interest).times(100)}}%</h6>
              </div>
              <div class="col">
                  <h6 class="font-weight-normal text-secondary">ดอกเบี้ยผิดนัดชำระ (%)</h6>
                  <h6>{{$big(contract.info.moneyPayload.dispute_interest).times(100)}}%</h6>
              </div>
          </div>

          <div class="row mt-4 mb-4">
              <div class="col">
                  <h6 class="font-weight-normal text-secondary" v-if="contract.type === 'MONEY'" for="duration">ระยะเวลาที่ขอกู้</h6>
                  <h6 class="font-weight-normal text-secondary" v-else-if="contract.type === 'THING'" for="duration">ระยะเวลาการผ่อนสินค้า</h6>

                  <template v-if="contract.type === 'MONEY' || contract.type === 'THING'">
                    <h6>{{contract.info.moneyPayload.duration}} เดือน</h6>
                  </template>
                  <template v-else>

                    <div class="row">
                      <div class="col-6">
                        <div class="form-group form-goobank">
                          <h6>{{contract.info.moneyPayload.durationYear}} ปี {{contract.info.moneyPayload.durationMonth}} เดือน</h6>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group form-goobank">
                          <label for="duration">&nbsp;</label>
                          <h6>&nbsp;</h6>
                        </div>
                      </div>
                    </div>

                  </template>

              </div>
              <div class="col">
                  <h6 class="font-weight-normal text-secondary">จำนวนงวด</h6>
                  <h6>{{contract.info.moneyPayload.duration}} งวด</h6>
                  <!-- HIDE THIS WHEN DISPUTING -->
              </div>
          </div>

          <div class="row mt-4 mb-4">
              <div class="col">
                  <h6 class="font-weight-normal text-secondary">ค่าธรรมเนียมในการกู้</h6>
                  <h6>{{contract.info.moneyPayload.fee | money}}</h6>
                  <!-- HIDE THIS WHEN DISPUTING -->
              </div>
              <div class="col">
                  <h6 class="font-weight-normal text-secondary">ชำระเงินทุกวันที่</h6>
                  <h6>{{contract.info.moneyPayload.payOnEvery}}</h6>
              </div>
          </div>
      </div>

      <div v-else-if="contract.type === 'MORTGAGE'" class="container pr-4 pl-4 pt-2 pb-2">
              <table class="table table-payment">
                  <tr>
                      <td>วันทำสัญญา</td>
                      <td>{{ contract.datetimeText }}</td>
                  </tr>
                  <tr>
                      <td>สถานะสัญญา</td>

                      <td v-if="contract.newPostponeStatus == 'DUE_TODAY'" class="text-warning">วันนี้ครบกำหนด</td>
                      <td v-if="contract.newPostponeStatus == 'ON_DUE'" class="text-success">ปกติ</td>
                      <td v-if="contract.newPostponeStatus == 'OVER_DUE'" class="text-danger">เกินกำหนด</td>
                      <td v-if="contract.newPostponeStatus == 'ON_EXEMPT'" class="text-warning">อยู่ในช่วงผ่อนผัน</td>
                      
                      <!-- <td class="text-success">***ปกติ***</td> -->
                  </tr>
              </table>

              <div class="row border-color-secondary">
                  <div class="col text-center p-3">
                      <h6 class="font-weight-normal m-0">รายละเอียดสัญญา</h6>
                  </div>
              </div>

              <table class="table table-payment">
                  <tr>
                      <td>เงินทำสัญญา</td>
                      <td>{{contract.info.moneyPayload.amount | money}}</td>
                  </tr>
                  <tr>
                      <td>เงินดาวน์</td>
                      <td>{{contract.info.thingPayload.downPaymentAmount | money}}</td>
                  </tr>
                  <tr>
                      <td>ดอกเบี้ย(%)</td>
                      <td>{{$big(contract.info.moneyPayload.interest).times(100)}}%</td>
                  </tr>
                  <tr>
                      <td>ดอกเบี้ยผิดนัดชำระ(%)</td>
                      <td>{{$big(contract.info.moneyPayload.dispute_interest).times(100)}}%</td>
                  </tr>
                  <tr>
                      <td>ระยะเวลาที่ขอกู้</td>
                      <td>{{contract.info.moneyPayload.durationYear}} ปี {{contract.info.moneyPayload.durationMonth}} เดือน</td>
                  </tr>
                  <tr>
                      <td>จำนวนงวด</td>
                      <td>{{contract.info.moneyPayload.duration}} งวด</td>
                  </tr>
                  <tr>
                      <td>ชำระเงินทุกวันที่</td>
                      <td>{{contract.info.moneyPayload.payOnEvery}}</td>
                  </tr>
                  <tr>
                      <td>ค่าธรรมเนียมในการกู้</td>
                      <td>{{contract.info.moneyPayload.fee | money}} บาท</td>
                  </tr>
              </table>


              <div class="row mt-4 mb-4">
                <div class="col">
                    <h6 class="font-weight-normal text-secondary">รูปถ่ายแนบสัญญา</h6>
                    <ImageViewer v-model="contract.info.thingPayload.imageURLs"></ImageViewer>
                </div>
              </div>


      </div>
      <template v-if="contract.status !== 'ended' && contract.status !== 'canceled'">
        <div class="container">
            <div class="row border-top border-bottom border-color-secondary">
                <div class="col text-center p-3">
                    <h6 class="font-weight-normal m-0">ชำระเงินงวดละ</h6>
                    <h3 class="text-danger m-0">{{contract.info.moneyPayload.perPeriod | money}}</h3>
                </div>
            </div>
        </div>
      </template>
      <div class="container">
        <error-cant-reach-server :errorData="errorData"  v-if="isCantReachWhenSubmit" class="mt-4 mr-2 ml-2" :disableCTA="true"></error-cant-reach-server>
        <error-not-enough-money v-if="isNotEnoughMoney" :side="isNotEnoughMoneySide" class="mt-4 mr-2 ml-2"></error-not-enough-money>
      </div>
      <template v-if="!isShowingCredit && contract.status !== 'wait_for_approve' && contract.status !== 'disputed' && contract.status !== 'ended' && contract.status !== 'rejected'">
        <div class="container pt-4 pr-4 pl-4 pb-2 bg-white">
          <h3>สถานะการชำระของแต่ละงวด</h3>
        </div>
        <div class="container p-0">
          <InvoiceList :contractId="parseInt($route.params.id, 10)" :contractType="this.contract.type"></InvoiceList>
        </div>
        <p class="h5 m-0 text-center" v-if="isAllowShowingDueAmountOrPaidAmount">
          <small>ยอดค้างจ่าย <span class="text-danger">{{display.dueAmount | money}} บาท</span></small><br />
          <small>ยอดจ่ายแล้ว <span class="text-success">{{display.paidAmount | money}} บาท</span></small>
        </p>
      </template>
      <template v-if="isShowingCredit">
        <div class="container pt-4 pr-4 pl-4 pb-2 bg-white">
          <h3>รายงานข้อมูลเครดิต</h3>
        </div>
        <div class="container p-0">
          <CreditBureauList :isAllowNavigate="false" :contractId="parseInt($route.params.id, 10)" :userId="contract.info.moneyPayload.korgoo.id" :showPrintButton="false"></CreditBureauList>
        </div>
        <p class="h5 m-0 text-center" v-if="isAllowShowingDueAmountOrPaidAmount">
          <small>ยอดค้างจ่าย <span class="text-danger">{{display.dueAmount | money}} บาท</span></small><br />
          <small>ยอดจ่ายแล้ว <span class="text-success">{{display.paidAmount | money}} บาท</span></small>
        </p>
      </template>


      <div v-if="contract.type === 'MORTGAGE'" class="container pr-4 pl-4 pt-4 pb-2">

        <div class="container pt-2 pr-1 pl-3 pb-1 bg-white">
          <h5>ตารางประวัติการชำระเงิน</h5>
          <div v-if="contract.tableGetPaidInvoices.length > 0" class="w-100" style="display:block; height: 360px; overflow-y: auto;">
            <table id="tb_datalist" class="table table-hover">
              <thead>
                  <tr>
                      <th>
                          <div class="text-btn header-text text-center">
                              <span>จ่ายงวดที่</span>
                          </div>
                      </th>
                      <th>
                          <div class="text-btn header-text text-center">
                              <span>วันครบกำหนด</span>
                          </div>
                      </th>
                      <th>
                          <div class="text-btn header-text text-center">
                              <span>จำนวนวันของเดือน</span>
                          </div>
                      </th>
                      <th>
                          <div class="text-btn header-text text-center">
                              <span>จำนวนวันคงค้างชำระ</span>
                          </div>
                      </th>

                      <th>
                          <div class="text-btn header-text text-right">
                              <span>เงินต้น</span>
                          </div>
                      </th>
                      <th>
                          <div class="text-btn header-text text-right">
                              <span>ดอกเบี้ย</span>
                          </div>
                      </th>
                      <th>
                          <div class="text-btn header-text text-right">
                              <span>ดอกเบี้ยปรับ</span>
                          </div>
                      </th>
                      
                      <th>
                          <div class="text-btn header-text text-right">
                              <span>จ่ายไป</span>
                          </div>
                      </th>
                      <th>
                          <div class="text-btn header-text text-right">
                              <span>เป็นเงินต้น</span>
                          </div>
                      </th>
                      <th>
                          <div class="text-btn header-text text-right">
                              <span>เป็นดอกเบี้ย</span>
                          </div>
                      </th>
                      <th>
                          <div class="text-btn header-text text-right">
                              <span>คงเหลือ</span>
                          </div>
                      </th>
                      <th>
                          <div class="text-btn header-text text-center">
                              <span>วันที่จ่ายจริง</span>
                          </div>
                      </th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="invoice in contract.tableGetPaidInvoices" :key="invoice.contract_id" :style="[invoice.is_postpone == 1 ? {'background-color': 'pink'} : invoice.is_postpone == 2 ? {'background-color': 'cyan'} : {}]">
                    <td class="text-center">
                        <span>{{ invoice.period_display || invoice.period }}</span>
                    </td>
                    <td class="text-center">
                        <span>{{ invoice.due_date | formatThaiDate }}</span>
                    </td>
                    <td class="text-center">
                        <span>{{ invoice.month_day_in_due_date }}</span>
                    </td>
                    <td class="text-center">
                        <span>{{ invoice.mortgage_exceed_days }}</span>
                    </td>
                    <td class="text-center">
                        <span>{{ (Number(invoice.mortgage_remain_amount || 0) + paidInvoicePrincipal(invoice)) | money }}</span>
                    </td>
                    <td class="text-right">
                        <span>{{ invoice.interest | money}}</span>
                    </td>
                    <td class="text-right">
                        <span>{{ invoice.dispute_interest | money }}</span>
                    </td>
                    <td class="text-right">
                        <span style="color:green">{{ invoice.total | money}}</span>
                    </td>
                    <td class="text-right">
                        <span>{{ paidInvoicePrincipal(invoice) | money}}</span>
                    </td>
                    <td class="text-right">
                        <span>{{ paidInvoiceInterest(invoice) | money}}</span>
                    </td>
                    <td class="text-right">
                        <span>{{ invoice.mortgage_remain_amount | money }}</span>
                    </td>
                    <td class="text-center">
                        <span>{{ invoice.paid_date | formatThaiDate }}</span>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else>
            ยังไม่มีประวัติการชำระเงิน
          </div>
        </div>


        <div v-if="contract.status !== 'ended' && contract.status !== 'canceled'" class="container pt-2 pr-1 pl-3 pb-1 bg-white">
          <h5>ตารางคำนวณค่าถัดไป</h5>
          <div v-if="contract.tableGetContractArrayEffectiveRate.length > 0" class="w-100" style="display:block; height: 360px; overflow-y: auto;">
            <table id="tb_datalist" class="table table-hover" >
                <thead>
                    <tr>
                        <th>
                            <div class="text-btn header-text text-center">
                                <span>งวดถัดไป</span>
                            </div>
                        </th>
                        <th>
                            <div class="text-btn header-text text-center">
                                <span>วันที่</span>
                            </div>
                        </th>
                        <th>
                            <div class="text-btn header-text text-center">
                                <span>จำนวนวันของเดือน</span>
                            </div>
                        </th>
                        <th>
                            <div class="text-btn header-text text-right">
                                <span>เงินต้น</span>
                            </div>
                        </th>
                        <th>
                            <div class="text-btn header-text text-right">
                                <span>ดอกเบี้ย</span>
                            </div>
                        </th>
                        <th>
                            <div class="text-btn header-text text-right">
                                <span>ค่างวด</span>
                            </div>
                        </th>
                        <th>
                            <div class="text-btn header-text text-right">
                                <span>เป็นเงินต้น</span>
                            </div>
                        </th>
                        <th>
                            <div class="text-btn header-text text-right">
                                <span>เป็นดอกเบี้ย</span>
                            </div>
                        </th>
                        <th>
                            <div class="text-btn header-text text-right">
                                <span>คงเหลือ</span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="result in tableGetContractArrayEffectiveRateShifted" :key="result.displayRound">
                    <td class="text-center">
                      <span>{{ result.displayRound }}</span>
                    </td>
                    <td class="text-center">
                      <span>{{ result.displayDate }}</span>
                    </td>
                      <td class="text-center">
                          <span>{{ getDisplayMonthDays(result.displayDate, result.month_days) }}</span>
                      </td>
                      <td class="text-right">
                          <span>{{ (result.principal_value && result.principal_value > 0 ? result.principal_value : ((result.remain || 0) + (result.is_principal_value || 0))) | money }}</span>
                      </td>
                      <td class="text-right">
                          <span>{{ (result.this_month_interest_value != null ? result.this_month_interest_value : result.interest_value) | money }}</span>
                      </td>
                      <td class="text-right">
                          <span style="color:red">{{ result.payment_value | money }}</span>
                      </td>
                      <td class="text-right">
                          <span>{{ result.is_principal_value | money }}</span>
                      </td>
                      <td class="text-right">
                          <span>{{ result.interest_value | money }}</span>
                      </td>
                      <td class="text-right">
                          <span>{{ result.remain | money }}</span>
                      </td>
                    </tr>
              </tbody>
            </table>
          </div>

          <div v-else>
            ไม่มีรายการค้างชำระ หรือ Contract ถูกปิดสมบูรณ์เรียบร้อยแล้ว
          </div>
        </div>
      </div>

      <div class="container p-4">
          <div class="container text-center" v-if="isActionPending">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <div class="mt-2">กำลังดำเนินการ...</div>
          </div>
          <template v-if="isDisputing && (parseFloat(display.disputing.fee) >= 0.0 && parseFloat(display.disputing.payPerPeriod) > 0.0)">
            <button class="btn btn-primary btn-lg btn-block" @click="disputingSubmitPatch()">แก้ไขสัญญาและส่งกลับให้ผู้ขอกู้</button>
          </template>
          <template v-if="isDisputing && !(parseFloat(display.disputing.fee) >= 0.0 && parseFloat(display.disputing.payPerPeriod) > 0.0)">
            <div class="row bg-white p-2">
              <div class="col text-center text-error">
                กรุณาตรวจสอบจำนวนเงินอีกครั้ง
                <template v-if="isCalculating()">
                  <p class="mt-2">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </p>
                </template>
              </div>
            </div>
          </template>
          <template v-if="!isActionPending && !isShowingCredit">
            <template v-if="contract.activeUserSide === 'KORGOO' && contract.status === 'disputed'">
              <!-- <span>korgoo/disputed</span> -->
              <button @click="korgooDisputedActionAccept()" class="btn btn-primary btn-lg btn-block">ยอมรับการแก้ไขและเริ่มต้นสัญญา</button>
              <button @click="korgooDisputedActionReject()" class="btn btn-danger btn-lg btn-block">ไม่ยอมรับการแก้ไขและยกเลิกสัญญา</button>
            </template>
            <template v-if="contract.activeUserSide === 'HAIGOO' && contract.status === 'wait_for_approve'">
              <!-- <span>haigoo/wait_for_approve</span> -->
              <button @click="haigooWaitForApproveActionApprove()" class="btn btn-primary btn-lg btn-block">อนุมัติสัญญา</button>
              <button @click="haigooWaitForApproveActionDispute()" class="btn btn-primary btn-lg btn-block">แก้ไขสัญญาบางส่วนและส่งกลับ</button>
              <button @click="haigooWaitForApproveActionDeny()" class="btn btn-danger btn-lg btn-block">ไม่อนุมัติสัญญา</button>
            </template>
            <template v-if="contract.activeUserSide === 'KORGOO' && contract.status === 'active'">
              <!-- <span>korgoo/active</span> -->
              <!-- UNUSED <button @click="korgooActiveActionRequestPostpone()" class="btn btn-primary btn-lg btn-block">ส่งขอผ่อนผันการชำระ</button> -->
              <!-- UNUSED <button @click="korgooActiveActionRequestCancel()" class="btn btn-danger btn-lg btn-block">ส่งขอยกเลิกสัญญา</button> -->
            </template>
            <template v-if="contract.activeUserSide === 'KORGOO' && contract.status === 'postponed'">
              <!-- <span>korgoo/postponed</span> -->
              <!-- UNUSED <button @click="korgooActiveActionRequestCancel()" class="btn btn-danger btn-lg btn-block">ขอยกเลิกสัญญา</button> -->
            </template>
            <template v-if="contract.activeUserSide === 'HAIGOO' && contract.status === 'active'">
              <!-- <span>haigoo/active</span> -->
              <!-- UNUSED <button @click="haigooActiveActionPostpone()" class="btn btn-danger btn-lg btn-block">ผ่อนผันการชำระให้ผู้กู้</button> -->
              <button @click="isShowingModalConfirmToCancel = true" class="btn btn-danger btn-lg btn-block">ยกเลิกสัญญาให้ผู้กู้</button>
              <button @click="haigooToChangeContract" class="btn btn-warning btn-lg btn-block">ผ่อนผันหรือเปลี่ยนแปลงสัญญา</button>
            </template>
            <template v-if="contract.activeUserSide === 'HAIGOO' && contract.status === 'postponed'">
              <!-- <span>haigoo/postponed</span> -->
              <button @click="isShowingModalConfirmToCancel = true" class="btn btn-danger btn-lg btn-block">ยกเลิกสัญญาให้ผู้กู้</button>            </template>
            </template>
            <stack-modal
              :show="isShowingModalConfirmToCancel"
              title="ยืนยันการยกเลิกสัญญา"
              @save="haigooActiveActionCancel()"
              @close="isShowingModalConfirmToCancel = false"
              :saveButton="{
                title: 'ยกเลิกสัญญา และยกหนี้ให้ผู้ขอกู้',
                visible: true,
                btnClass: {'btn btn-danger': true}
              }"
              :cancelButton="{
                title: 'ไม่ยกเลิกสัญญา และปิดหน้าต่างนี้',
                visible: true,
                btnClass: {'btn btn-light': true}
              }">
              <p class="m-0">คุณต้องการยกเลิกสัญญานี้ให้ผู้กู้ใช้หรือไม่?<br/>ส่วนเงินที่เหลือจะถูกยกหนี้ให้ผู้ขอกู้</p>
            </stack-modal>
          
          <button v-if="this.contract.type === 'MORTGAGE' && (contract.status === 'wait_for_approve' || contract.status === 'disputed')" @click="goToEditLandDetailForm" class="btn btn-primary btn-lg btn-block">แก้ไขรายการบ้าน/ที่ดินก่อนพิมพ์สัญญา</button>

          <a class="btn btn-primary btn-lg btn-block" target="_blank" :href="getUrlViewPDF()"
          v-if="contract.status === 'active' || contract.status === 'ended' || contract.status === 'postponed'">เอกสารสัญญา</a>

          <a class="btn btn-primary btn-lg btn-block" target="_blank" :href="getUrlViewPDF()"
          v-if="contract.status === 'wait_for_approve' || contract.status === 'disputed'">เอกสารสัญญา (ฉบับร่าง)</a>
          <button class="btn btn-light btn-lg btn-block" @click="$router.go(-1)">ย้อนกลับ</button>
      </div>
    </template>
</div>
</template>

<script>
import ImageViewer from '../../sub_components/ImageViewer'
import ImageUploader from '../../sub_components/ImageUploader'
import ContractFlowPairDisplay from '../../sub_components/ContractFlowPairDisplay'
import CreditBureauList from '../../sub_components/CreditBureauList'
import InvoiceList from '../../sub_components/InvoiceList'
import dateFormat from '../../utils/date.js';

export default {
  data: () => ({
    calculateTimeout: {},
    isPendingCalculateFee: true,

    interestRaw: 0.0,
    interestDisputeRaw: 0.0,

    isShowingModalConfirmToCancel: false,
    isAllowShowingDueAmountOrPaidAmount: true,
    isNotEnoughMoney: false,
    isNotEnoughMoneySide: 'b',
    isCantReach: false,
    errorData: {},
    isCantReachWhenSubmit: false,
    isActionPending: false, // Can be used to disable buttons
    isFinalContractView: false,
    isFinalContractDispute: false,
    isPreProcessing: true,
    isShowingCredit: false,
    display: {
      dueAmount: '?',
      paidAmount: '?',
      disputing: {
        payPerPeriod: '?',
        fee: '?',
        lender_fee: '?',
      },
      popup: {
        title: '',
        description: ''
      },
      optionLists: {
        interest: [
            { value: 0.00, display: '0 %' },
            { value: 0.01, display: '1 %' },
            { value: 0.02, display: '2 %' },
            { value: 0.03, display: '3 %' },
            { value: 0.04, display: '4 %' },
            { value: 0.05, display: '5 %' },
            { value: 0.06, display: '6 %' },
            { value: 0.07, display: '7 %' },
            { value: 0.08, display: '8 %' },
            { value: 0.09, display: '9 %' },
            { value: 0.10, display: '10 %' },
            { value: 0.11, display: '11 %' },
            { value: 0.12, display: '12 %' },
            { value: 0.13, display: '13 %' },
            { value: 0.14, display: '14 %' },
            { value: 0.15, display: '15 %' },
        ],
        duration: [
            { value: 1, display: '1 เดือน' },
            { value: 2, display: '2 เดือน' },
            { value: 3, display: '3 เดือน' },
            { value: 4, display: '4 เดือน' },
            { value: 5, display: '5 เดือน' },
            { value: 6, display: '6 เดือน' },
            { value: 7, display: '7 เดือน' },
            { value: 8, display: '8 เดือน' },
            { value: 9, display: '9 เดือน' },
            { value: 10, display: '10 เดือน' },
            { value: 11, display: '11 เดือน' },
            { value: 12, display: '1 ปี' },
            { value: 13, display: '1 ปี 1 เดือน' },
            { value: 14, display: '1 ปี 2 เดือน' },
            { value: 15, display: '1 ปี 3 เดือน' },
            { value: 16, display: '1 ปี 4 เดือน' },
            { value: 17, display: '1 ปี 5 เดือน' },
            { value: 18, display: '1 ปี 6 เดือน' },
            { value: 19, display: '1 ปี 7 เดือน' },
            { value: 20, display: '1 ปี 8 เดือน' },
            { value: 21, display: '1 ปี 9 เดือน' },
            { value: 22, display: '1 ปี 10 เดือน' },
            { value: 23, display: '1 ปี 11 เดือน' },
            { value: 24, display: '2 ปี' },
            { value: 25, display: '2 ปี 1 เดือน' },
            { value: 26, display: '2 ปี 2 เดือน' },
            { value: 27, display: '2 ปี 3 เดือน' },
            { value: 28, display: '2 ปี 4 เดือน' },
            { value: 29, display: '2 ปี 5 เดือน' },
            { value: 30, display: '2 ปี 6 เดือน' },
            { value: 31, display: '2 ปี 7 เดือน' },
            { value: 32, display: '2 ปี 8 เดือน' },
            { value: 33, display: '2 ปี 9 เดือน' },
            { value: 34, display: '2 ปี 10 เดือน' },
            { value: 35, display: '2 ปี 11 เดือน' },
            { value: 36, display: '3 ปี' },
            { value: 37, display: '3 ปี 1 เดือน' },
            { value: 38, display: '3 ปี 2 เดือน' },
            { value: 39, display: '3 ปี 3 เดือน' },
            { value: 40, display: '3 ปี 4 เดือน' },
            { value: 41, display: '3 ปี 5 เดือน' },
            { value: 42, display: '3 ปี 6 เดือน' },
            { value: 43, display: '3 ปี 7 เดือน' },
            { value: 44, display: '3 ปี 8 เดือน' },
            { value: 45, display: '3 ปี 9 เดือน' },
            { value: 46, display: '3 ปี 10 เดือน' },
            { value: 47, display: '3 ปี 11 เดือน' },
            { value: 48, display: '4 ปี' },
        ],
        durationYearMortgage: [
          // generate in populateDurationYearMortgage function
        ],
        durationMonthMortgage: [
          // generate in populateDurationMonthMortgage function
        ],
        payOnEvery: []
      },
    },
    patch: {
      moneyPayload: {
        haigoo: {
          id: -1,
          avatarPath: '',
          name: '',
          memberType: ''
        },
        korgoo: {
          id: -1,
          avatarPath: '',
          name: '',
          memberType: ''
        },
        amount: 0.00,
        interest: 0.00,
        dispute_interest: 0.00,
        duration: 1,
        payOnEvery: 1,
        fee: 0,
        perPeriod: 0
      },
      // have thingPayload if type = 'THING'
      thingPayload: {
        thingName: '',
        downPaymentAmount: 0.00,
        imageURLs: []
      }
    },
    contract: {
      id: -1,
      type: '', // 'MONEY' or 'THING'
      activeUserSide: '',
      status: '',
      datetime: 0,
      info: {
        moneyPayload: {
          haigoo: {
            id: -1,
            avatarPath: '',
            name: '',
            memberType: ''
          },
          korgoo: {
            id: -1,
            avatarPath: '',
            name: '',
            memberType: ''
          },
          amount: 0.00,
          interest: 0.00,
          duration: 1,
          durationYear: 1,
          durationMonth: 1,
          payOnEvery: 1,
          fee: 0,
          perPeriod: 0
        },
        // have thingPayload if type = 'THING'
        thingPayload: {
          thingName: '',
          downPaymentAmount: 0.00,
          imageURLs: []
        }
      }
    },
    calculateQueue: []
  }),

  computed: {
    lastPaidPeriod() {
      const arr = (this.contract && this.contract.tableGetPaidInvoices) ? this.contract.tableGetPaidInvoices : [];
      if (!arr.length) return 0;

      // ใช้ค่าสูงสุดของ invoice.period (กันกรณีมีงวดพิเศษ/โพสต์โพน)
      let max = 0;
      arr.forEach(i => {
        const p = Number(i.period) || 0;
        if (p > max) max = p;
      });
      return max;
    },

    periodOffset() {
      // ถ้าจ่ายแล้ว 27 งวด → offset 26 เพื่อให้แถวแรกแสดงเป็นงวด 27
      return this.lastPaidPeriod > 0 ? (this.lastPaidPeriod - 1) : 0;
    },

    tableGetContractArrayEffectiveRateShifted() {
  const base = (this.contract && Array.isArray(this.contract.tableGetContractArrayEffectiveRate))
    ? this.contract.tableGetContractArrayEffectiveRate
    : [];

  const forecastRows = base.filter(r => r.row_type !== 'actual');
  const source = forecastRows.length > 0 ? forecastRows : base;
  const sorted = [...source].sort((a, b) => (Number(a.round) || 0) - (Number(b.round) || 0));

  return sorted.map(r => ({
    ...r,
    displayRound: Number(r.round) || Number(r.displayRound) || 0,
    displayDate: r.myday_formatted || null,
  }));
}
  },


  async created () {
    this.populateOptions()
    $('.bottom-nav').css('display', 'none')
    $('.bottom-nav-pusher').css('display', 'none')
    this.isPreProcessing = true
    const result = await this.$api.contract.list(this.$route.params.id);
    const data = result.data
    if (!data.success) {
      this.isCantReach = true
      this.errorData = data
      return
    }
    this.contract = data.contracts[0];

    const getInvoices = await this.$api.pay.getInvoices(this.$route.params.id)
    const getInvoicesData = getInvoices.data
    if (!getInvoicesData.success) {
      this.isAllowShowingDueAmountOrPaidAmount = false
    } else {
      this.calculateDisplayMoney(getInvoicesData.contractDetail)
    }

    // if (this.$route.query.show === 'credit') {
    if (this.isShowCredit) {
      console.log('viewing credit')
      this.isShowingCredit = true
    } // then set this view to "ประวัติเครดิต"
    this.isPreProcessing = false
  },
  mounted () {
    if (this.$route.query.show === 'credit') $('.header-expand-content h3').html('ประวัติเครดิต')
  },
  filters: {
    formatThaiDate: function (value) {
      return dateFormat.dateNotBeauty(value);
    }
  },
  beforeDestroy () {
    $('.bottom-nav').css('display', 'block')
    $('.bottom-nav-pusher').css('display', 'block')
  },
  watch: {
    interestRaw: function (val) {
      this.patch.moneyPayload.interest = val / 100.00;
    },
    interestDisputeRaw: function (val) {
      this.patch.moneyPayload.dispute_interest = val / 100.00;
    },
    patch: { // for disputing
      async handler () {
        await this.emitCalculate()
      },
      deep: true
    }
  },
  methods: { // Require much attention and testing, methods name: <user-side><contract-status>Action<actionName>()
    // v FOR DISPUTING

    addMonthsToDMY(dmy, monthsToAdd) {
      // รองรับ "28/06/2023"
      if (!dmy) return dmy;
      const parts = String(dmy).split('/');
      if (parts.length !== 3) return dmy;

      const d = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10);
      const y = parseInt(parts[2], 10);

      if (!d || !m || !y) return dmy;

      const date = new Date(y, m - 1 + monthsToAdd, d);

      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = String(date.getFullYear());

      return `${dd}/${mm}/${yyyy}`;
    },

    getDisplayMonthDays(displayDate, fallbackDays = null) {
      if (!displayDate) return fallbackDays;

      const parts = String(displayDate).split('/');
      if (parts.length !== 3) return fallbackDays;

      const d = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10);
      const y = parseInt(parts[2], 10);
      if (!d || !m || !y) return fallbackDays;

      return new Date(y, m, 0).getDate();
    },

    paidInvoicePrincipal (invoice) {
      if (!invoice) return 0
      let v = 0
      if (invoice.principle !== undefined && invoice.principle !== null) v = invoice.principle
      else if (invoice.principal !== undefined && invoice.principal !== null) v = invoice.principal
      else if (invoice.is_principle !== undefined && invoice.is_principle !== null) v = invoice.is_principle
      else if (invoice.is_principal !== undefined && invoice.is_principal !== null) v = invoice.is_principal
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },

    paidInvoiceInterest (invoice) {
      if (!invoice) return 0
      const normalRaw = (invoice.interest !== undefined && invoice.interest !== null) ? invoice.interest : invoice.is_interest
      const disputeRaw = (invoice.dispute_interest !== undefined && invoice.dispute_interest !== null) ? invoice.dispute_interest : invoice.is_dispute_interest
      const normal = Number((normalRaw !== undefined && normalRaw !== null) ? normalRaw : 0)
      const dispute = Number((disputeRaw !== undefined && disputeRaw !== null) ? disputeRaw : 0)
      const total = (Number.isFinite(normal) ? normal : 0) + (Number.isFinite(dispute) ? dispute : 0)
      return total
    },

    async disputingSubmitPatch () {
      const result = await this.$api.contract.actions.haigoo.waitForApprove.dispute(this.contract.id, this.patch)
      const data = result.data
      if (data.success) this.isFinalContractDispute = true
      else this.isCantReachWhenSubmit = true
    },
    calculateDisplayMoney (contractDetail) {
        this.display.dueAmount = contractDetail.remaining
        this.display.paidAmount = contractDetail.paid
    },
    async emitCalculate () {
      this.isCantReach = false
      this.isNotEnoughMoney = false
      this.isCantReachWhenSubmit = false
      this.isPendingCalculateFee = true
      try {
        clearTimeout(this.calculateTimeout)
      } catch (e) { console.warn(e) }
      this.calculateTimeout = setTimeout(async () => {
        this.display.disputing.payPerPeriod = '?'
        this.display.disputing.fee = '?'
        this.display.disputing.lender_fee = '?'

        if(this.contract.type === 'MORTGAGE') {
          this.patch.moneyPayload.duration = this.patch.moneyPayload.durationYear * 12 + this.patch.moneyPayload.durationMonth;
          let dataTemp = await this.calculatePayPerPeriod();
          this.display.disputing.payPerPeriod = dataTemp.perPeriodRounded;
        } else {
          this.display.disputing.payPerPeriod = await this.calculatePayPerPeriod()
        }

        const feeObj = await this.calculateFee()
        this.display.disputing.fee = feeObj.fee
        this.display.disputing.lender_fee = feeObj.lender_fee

        this.isPendingCalculateFee = false
      }, 1500)
    },
    isCalculating () {
      if (this.calculateQueue.length > 0 || this.isPendingCalculateFee) return true
      return false
    },
    async calculateFee () {
      this.calculateQueue.push(1)
      console.log(this.patch)
      const resultFee = await this.$api.contract.request.newContract.fee(this.patch.moneyPayload.amount, this.patch.thingPayload.downPaymentAmount)
      const dataFee = resultFee.data
      if (!dataFee.success) {
        this.calculateQueue.pop()
        this.isCantReach = true
        this.errorData = data
        return {
          fee: -1,
          lender_fee: -1,
          viewCreditFee: -1
        }
      }
      this.calculateQueue.pop()
      return {
        fee: dataFee.fee,
        lender_fee: dataFee.lender_fee,
      }
    },
    async calculatePayPerPeriod () {
        this.calculateQueue.push(1)
        let result;
        if (this.contract.type === 'MONEY') {
          result = await this.$api.contract.calculatePayPerPeriod(this.patch.moneyPayload.amount, this.patch.moneyPayload.interest, this.patch.moneyPayload.duration)
        } else if(this.contract.type === 'THING') {
          result = await this.$api.contract.calculatePayPerPeriod(this.patch.moneyPayload.amount, this.patch.moneyPayload.interest, this.patch.moneyPayload.duration, this.patch.thingPayload.downPaymentAmount)
        } else if(this.contract.type === 'MORTGAGE') {
          result = await this.$api.contract.calculatePMT(this.patch.moneyPayload.amount, this.patch.moneyPayload.interest, this.patch.moneyPayload.duration)
        }
        const data = result.data
        if (!data.success) {
          this.calculateQueue.pop()
          // this.isCantReach = true
          this.errorData = data
          return
        }
        this.calculateQueue.pop()

        if(this.contract.type === 'MORTGAGE') {
          return data;
        } else {
          return data.perPeriod;
        }
    },
    // ^ FOR DISPUTING

    populateOptions () {
      [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31].forEach((elm) => {
          this.display.optionLists.payOnEvery.push({
              value: elm,
              display: elm
          })
      });
    },
    populateDurationYearMortgage () {
        this.display.optionLists.durationYearMortgage = [];
        let i = 3;
        for(i = 3; i<= 30; i++) {
            let year = i;
            let display = "";

            display = year + " ปี ";
            this.display.optionLists.durationYearMortgage.push({
                value: i,
                display: display
            });
        }
    },
    populateDurationMonthMortgage () {
        this.display.optionLists.durationMonthMortgage = [];
        let i = 0;
        for(i = 0; i<= 11; i++) {
            let month = i;
            let display = "";

            display = month + " เดือน ";
            this.display.optionLists.durationMonthMortgage.push({
                value: i,
                display: display
            });
        }
    },
    actionPending () {
      this.isActionPending = true
      this.isCantReachWhenSubmit = false
    },
    async korgooDisputedActionAccept () {
      this.actionPending()
      const result = await this.$api.contract.actions.korgoo.disputed.accept(this.contract.id)
      const data = result.data
      if (!data.success) {
        if (data.code === 'W-MONEY_INSUFFICENT') {
          this.isNotEnoughMoney = true
        } else if (data.code === 'W-MONEY_INSUFFICENT_B') {
          this.isNotEnoughMoney = true
          this.isNotEnoughMoneySide = 'b'
        } else if (data.code === 'W-MONEY_INSUFFICENT_L') {
          this.isNotEnoughMoney = true
          this.isNotEnoughMoneySide = 'l'
        } else {
          this.isCantReachWhenSubmit = true
        }
        this.isActionPending = false
        return
      }
      this.display.popup.title = 'ส่งคำขอเสร็จสิ้น'
      this.display.popup.description = 'ผู้ให้กู้จะได้รับการแจ้งเตือนว่าคุณยอมรับการแก้ไขและเริ่มต้นสัญญา'
      this.isFinalContractView = true
    },
    async korgooDisputedActionReject () {
      this.actionPending()
      const result = await this.$api.contract.actions.korgoo.disputed.reject(this.contract.id)
      const data = result.data
      if (!data.success) {
        this.isCantReachWhenSubmit = true
        this.isActionPending = false
        return
      }
      this.display.popup.title = 'ยกเลิกสัญญาเสร็จสิ้น'
      this.display.popup.description = 'ผู้ให้กู้จะได้รับการแจ้งเตือนว่าคุณไม่ยอมรับการแก้ไขและสัญญาได้ถูกยกเลิกแล้ว'
      this.isFinalContractView = true
    },
    async haigooWaitForApproveActionApprove () {
      this.actionPending()
      const result = await this.$api.contract.actions.haigoo.waitForApprove.approve(this.contract.id)
      const data = result.data
      if (!data.success) {
        if (data.code === 'W-MONEY_INSUFFICENT') {
          this.isNotEnoughMoney = true
        } else if (data.code === 'W-MONEY_INSUFFICENT_B') {
          this.isNotEnoughMoney = true
          this.isNotEnoughMoneySide = 'b'
        } else if (data.code === 'W-MONEY_INSUFFICENT_L') {
          this.isNotEnoughMoney = true
          this.isNotEnoughMoneySide = 'l'
        } else {
          this.isCantReachWhenSubmit = true
        }
        this.isActionPending = false
        return
      }
      this.display.popup.title = 'อนุมัติสัญญาเสร็จสิ้น'
      this.display.popup.description = 'ผู้ขอกู้จะได้รับการแจ้งเตือนเพื่อแจ้งความคืบหน้าของสัญญา'
      this.isFinalContractView = true
    },
    async haigooWaitForApproveActionDispute () { // not easy
      this.actionPending()
      this.$router.push({
        name: 'transaction-contract-dispute',
        params: {
          id: this.contract.id,
          type: this.contract.type.toLowerCase()
        }
      })
    },
    async haigooWaitForApproveActionDeny () {
      this.actionPending()
      const result = await this.$api.contract.actions.haigoo.waitForApprove.deny(this.contract.id)
      const data = result.data
      if (!data.success) {
        this.isCantReachWhenSubmit = true
        this.isActionPending = false
        return
      }
      this.display.popup.title = 'สัญญาไม่อนุมัติ'
      this.display.popup.description = 'ผู้ขอกู้จะได้รับการแจ้งเตือนเพื่อแจ้งความคืบหน้าของสัญญา'
      this.isFinalContractView = true
    },
    async haigooActiveActionPostpone () {
      this.actionPending()
      const result = await this.$api.contract.actions.haigoo.active.postpone(this.contract.id)
      const data = result.data
      if (!data.success) {
        this.isCantReachWhenSubmit = true
        this.isActionPending = false
        return
      }
      this.display.popup.title = 'ผ่อนผันสัญญาแล้ว'
      this.display.popup.description = 'ผู้ขอกู้จะได้รับการผ่อนผันการชำระเงินในงวดปัจจุบัน'
      this.isFinalContractView = true
    },
    async haigooActiveActionCancel () {
      this.isShowingModalConfirmToCancel = false
      this.actionPending()
      const result = await this.$api.contract.actions.haigoo.active.cancel(this.contract.id)
      const data = result.data
      if (!data.success) {
        this.isCantReachWhenSubmit = true
        this.isActionPending = false
        return
      }
      this.display.popup.title = 'ยกเลิกสัญญาแล้ว'
      this.display.popup.description = 'ผู้ขอกู้จะได้รับการแจ้งเตือนความคืบหน้าของสัญญานี้'
      this.isFinalContractView = true
    },
    async korgooActiveActionRequestPostpone () {
      this.actionPending()
      const result = await this.$api.contract.actions.korgoo.active.requestPostpone(this.contract.id)
      const data = result.data
      if (!data.success) {
        this.isCantReachWhenSubmit = true
        this.isActionPending = false
        return
      }
      this.display.popup.title = 'ส่งคำขอผ่อนผันแล้ว'
      this.display.popup.description = 'หาผู้ให้กู้อนุมัติคำขอของคุณ คุณจะได้รับการแจ้งเตือน'
      this.isFinalContractView = true
    },
    async korgooActiveActionRequestCancel () {
      this.actionPending()
      const result = await this.$api.contract.actions.korgoo.active.requestCancel(this.contract.id)
      const data = result.data
      if (!data.success) {
        this.isCantReachWhenSubmit = true
        this.isActionPending = false
        return
      }
      this.display.popup.title = 'ส่งคำขอยกเลิกสัญญาแล้ว'
      this.display.popup.description = 'หาผู้ให้กู้อนุมัติคำขอของคุณ คุณจะได้รับการแจ้งเตือน'
      this.isFinalContractView = true
    },
    goToEditLandDetailForm() {
      // return this.$util.url(`member/api/contract/view-pdf/${this.contract.id}`);
      this.$router.push({ name: 'transaction-contract-edit-land-detail-form', params: { id: this.contract.id } });
    },
    getUrlViewPDF() {
        return this.$util.url(`member/api/contract/view-pdf/${this.contract.id}`);
    },
    haigooToChangeContract() {
      this.$router.push({ name: 'transaction-contract-change-status', params: { id: this.contract.id } });
    }
  },
  components: {
    ImageViewer,
    ContractFlowPairDisplay,
    CreditBureauList,
    ImageUploader,
    InvoiceList
  },
  props: ['isShowCredit'] // isShowCredit passed by routes passed by routes
}
</script>

<style lang="scss">
.contract-view {
  .active-user-indicator {
      display: none;
    }
  .is-active-user {
    .active-user-indicator {
      display: inline-block;
    }
  }
  .disputing-old-value {
    margin-top: 6px;
    font-size: 14px;
    opacity: 0.5;
    &::before {
      content: '(ค่าเดิม: '
    }
    &::after {
      content: ')'
    }
  }
  .disputing-old-value-2 {
    margin-top: 6px;
    font-size: 14px;
    opacity: 0.5;
  }
}
</style>
